import { ReactElement } from 'react'

import classNames from 'classnames'

import { ToolTip } from 'components/ToolTip'
import { usePermissionMessage } from 'hooks/usePermissionMessage'

import * as styles from './styles.module.scss'
import { PermissionTooltipProps } from './types'

/** Explains a missing permission on hover; disabling the child stays the caller's job. */
export const PermissionTooltip = ({
    hasPermission,
    placement = 'top',
    block = false,
    children,
}: PermissionTooltipProps): ReactElement => {
    const message = usePermissionMessage()

    if (hasPermission) {
        return children
    }

    return (
        <ToolTip title={message} placement={placement}>
            <span
                className={classNames(styles.wrapper, {
                    [styles.block]: block,
                })}
            >
                {children}
            </span>
        </ToolTip>
    )
}
